export default __webpack_public_path__ + "static/media/plus-circle2.f3033825.svg";